import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import NewMachineGPSPanel from "./MachineGPSPanel";
import ManualViewer from "../Components/ManualViewer";
import axios from "axios";
import {Switch} from "@mui/material";
import EnergyChart from "../Data/EnergyChart";
import DateSelectorNew from "../Components/DateSelector";
import EnergyTable from "../Data/EnergyTable";
import L from 'leaflet'
import leafletImage from "leaflet-image"
import {Polyline} from "react-leaflet";


const MachineDashboard = () => {
  const timeobj = new Date();
  const start = new Date(timeobj.getFullYear(), timeobj.getMonth(), timeobj.getDate() - 1, 0, 0, 0).toISOString()
  const stop = new Date(timeobj.getFullYear(), timeobj.getMonth(), timeobj.getDate(), 23, 59, 59).toISOString();
  const { serialNumber } = useParams();
  const [machine, setMachine] = useState(null)
  const [livedata, setLivedata] = useState(null)
  const [machineStatus, setMachineStatus] = useState(null)
  const [Data, setData] = useState(null);
  const [Totaal, setTotaal] = useState(null);
  const [chargeTime, setChargeTime] = useState("--:--")
  const [chargeWattage, setChargeWattage] = useState(0)
  const [driverHours, setDriverHours] = useState(null)
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [Tabel, setTabel] = useState(false)
  const [workTimeRemaining, setWorkTimeRemaining] = useState("--:--");
  const [imgUrl, setImgUrl] = useState(null)
  const [dateRangeOpen, setdateRangeOpen] = useState(false)
  const [ScreenMessages , setScreenMessages] = useState([])
  const [dateRange, setDateRange] = useState([start, stop]);
  const [filters, setFilters] = useState({})
  const [Admin, setAdmin] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
        const user = response.data.user.organization;
        if (user === "admin") {
          setAdmin(true)
        }
      } catch (error) {
        console.log(error)
      }
    };

    checkAuth();
  }, []);

  const fetchData = async () => {
    setData(null)
    let url = `/api/influx/energy/onderwagen/${machine.serialNumber}`
    try {
      const response = await axios.get(url, {
        params: { machineOrg: machine.organization, machine:machine, start: dateRange[0], stop: dateRange[1] },
      });
      if (response?.data?.data) {
        setData(response.data.data);
        setTotaal(response.data.totals)
        let newFilters = {}
        Object.entries(response.data.data[0]).forEach((element) => {
          if (!element[1].value) return
          newFilters[element[0]] = {
            value: true,
            name: element[1].name,
            color: element[1].color,
          }
        })
        setFilters(newFilters);
      }
      else setData({error: "Geen Data Gevonden"});
    } catch (e) {
      setData({error: "Geen Data Gevonden"});
      console.log(e);
    }
  }

  const fetchSubscriptionStatus = async () => {
    try {
      const response = await axios.get(`/api/mail/subscription-status`, {
        params: { serialNumber },
      });
      setIsSubscribed(response.data.isSubscribed);
    } catch (error) {
      console.error(`Error fetching subscription status for ${serialNumber}:`, error);
    }
  };

  const fetchScreen = async () => {
    try {
      setScreenMessages(["Laden..."])

      const response = await axios.get(`/api/influx/screen/get/${serialNumber}`, {
        params: {
          machineOrg: machine.organization,
          start: dateRange[0],
          stop: dateRange[1]
        }
      })

      setScreenMessages(response.data)
    } catch (error) {
      console.error("Error fetching driver hours:", error);
    }
  }

  const fetchImgUrl = async () => {
    try {
      setImgUrl(null);
      const response = await axios.get(`/api/img/${serialNumber}`, {
        withCredentials: true,
      });

      if (response.status === 200 && response.data.url) {
        setImgUrl(response.data.url);
      } else {
        setImgUrl(undefined);
      }
    } catch (err) {
      setImgUrl(undefined);
    }
  };

  const calculateWorkTimeRemaining = async () => {
    try {
      setWorkTimeRemaining("Laden...")

      const {remainingCapacity} = calculateAverageSoC();

      const workPower = await axios.get(`/api/influx/workpower/${serialNumber}`, {
        params: {
          machineOrg: machine.organization,
          start: dateRange[0],
          stop: dateRange[1]
        },
      });

      if (workPower.data.AvgPower/1000 > 0) {
        const timeInHours = remainingCapacity / (workPower.data.AvgPower / 1000);
        const hours = Math.floor(timeInHours);
        const minutes = Math.floor((timeInHours - hours) * 60);
        setWorkTimeRemaining(`${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`)
      } else {
        setWorkTimeRemaining("--:--")
      }
    } catch (error) {
      console.error("Error calculating remaining worktime:", error);
    }
  };

  const calculateAverageSoC = () => {
    const socValues = machine.batteries
      .map((_, index) => livedata[`Soc${index + 1}`])
      .filter((soc) => soc !== undefined);

    const averageSoc =
      socValues.reduce((sum, soc) => sum + soc, 0) / socValues.length || 0;

    const remainingCapacity = machine.batteries.reduce((sum, battery, index) => {
      const soc = livedata[`Soc${index + 1}`];
      return sum + ((soc || 0) * 0.008 * battery.capacity);
    }, 0);

    const totalCapacity = machine.batteries.reduce((sum, battery) => {
      return sum + 0.8 * battery.capacity;
    }, 0);

    return { averageSoc, socValues, remainingCapacity, totalCapacity };
  };

  const calculateChargeData = async () => {
    const { totalCapacity, remainingCapacity } = calculateAverageSoC();
    const chargingCapacity = totalCapacity - remainingCapacity;
    setChargeWattage("Laden...")
    setChargeTime("Laden...")

    const response = await axios.get(`/api/influx/charging/${machine.serialNumber}`, {
      params: {machineOrg: machine.organization},
    });

    console.log(response)

    if (response.data.vermogen > 0) {
      const timeInHours = chargingCapacity / response.data.vermogen;
      const hours = Math.floor(timeInHours);
      const minutes = Math.floor((timeInHours - hours) * 60);
      setChargeTime(`${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`)
      setChargeWattage(response.data.vermogen);
    } else {
      setChargeWattage(0)
      setChargeTime("--:--")
    }
  };

  const handleSubscriptionToggle = async () => {
    try {
      const endpoint = isSubscribed ? "/api/mail/unsubscribe" : "/api/mail/subscribe";
      const response = await axios.post(endpoint, { serialNumber });
      setIsSubscribed(!isSubscribed);
      console.log(response.data.success);
    } catch (error) {
      console.error("Error toggling subscription:", error);
    }
  };

  const fetchDriverHours = async () => {
    try {
      const response = await axios.get(`/api/influx/driverhours/${machine.serialNumber}`, {
        params: { machineOrg: machine.organization },
      });
      setDriverHours(response.data.hours);
    } catch (error) {
      console.error("Error fetching driver hours:", error);
    }
  };

  const getMachine = async () => {
    const response = await axios.get(`/api/machine/get/${serialNumber}`);

    setMachine(response.data);
  }

  const getLivedata = async () => {
    const response = await axios.get(`/api/live/${serialNumber}`);

    setLivedata(response.data);
  }

  const getMachineStatus = () => {
    if (livedata.IsCharging) setMachineStatus({ status: "Laden", icon: "⚡", color: "text-yellow-500" });
    else if (livedata.IsRunning) setMachineStatus({ status: "Draait", icon: "●", color: "text-green-500" });
    else setMachineStatus({ status: "Uit", icon: "●", color: "text-gray-400" });
  };

  const exportData = async () => {
    if (Data.error) {
      window.alert("Geen Data");
      return;
    }

    const projectNummer = window.prompt("Projectnummer");

    if (!projectNummer) return;

    const canvas = document.getElementById("canvas-draw-chart");
    const chartUrl = canvas.toDataURL();
    const canvas2 = document.getElementById("canvas-draw-tabel");
    const tableUrl = canvas2.toDataURL();

    const mapContainer = document.createElement("div");
    mapContainer.id = "map";
    mapContainer.style.width = "2000px";
    mapContainer.style.height = "1000px";
    document.body.appendChild(mapContainer);

    let latmin = 999
    let latmax = 0
    let lngmin = 999
    let lngmax = 0

    Totaal.pos.forEach((item) => {
      latmin = Math.min(item[0], latmin)
      latmax = Math.max(item[0], latmax)
      lngmin = Math.min(item[1], lngmin)
      lngmax = Math.max(item[1], lngmax)
    })

    const map = L.map('map', {preferCanvas: true}).setView([0, 0], 15);
    map.fitBounds([[latmin, lngmin], [latmax ,lngmax]])
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

    L.polyline(Totaal.pos, {
      color: 'red',
      weight: 3,
      opacity: 1,
      smoothFactor: 1
    }).addTo(map);

    await leafletImage(map, async function (err, canvas) {
      let mapUrl = canvas.toDataURL()

      const url = (await axios.post("api/export", {chartUrl, tableUrl, projectNummer, machine, mapUrl})).data

      let download = document.createElement("a")
      download.href=url
      download.download = projectNummer + ".pdf"
      download.click();
    });

    mapContainer.remove();
  }

  useEffect(() => {
    getMachine();
    getLivedata();
  }, [serialNumber]);

  useEffect(() => {
    if (!livedata || !machine) return;
    getMachineStatus()
    fetchDriverHours()
    fetchSubscriptionStatus()
    calculateWorkTimeRemaining()
    calculateChargeData()
    fetchImgUrl()
    fetchScreen()
    fetchData()
  }, [machine, livedata, dateRange, serialNumber]);

  if (!machine || !livedata || !machineStatus) return;

  if (machine.serviceMode && !Admin) return (
    <div>
      <div className={"text-9xl font-bold text-wrap flex px-16 py-52 text-center text-"}>Deze machine word momenteel onderhouden</div>
      <a href={"/"} className={"absolute left-3 top-16 bg-red-600 text-white  rounded-lg p-3 shadow font-bold text-3xl"}>Back</a>
    </div>
  )

  const { socValues } = calculateAverageSoC();

  return (
      <div id={"base"} className="px-2 pb-1 gap-2 w-full h-full grid grid-cols-8">
        <div id={"datetime"} className={(dateRangeOpen ? "flex" : "hidden") + " fixed sm:bottom-3 sm:left-3 bottom-14 left-1/2 sm:translate-x-0 -translate-x-1/2 z-10"}>
          <DateSelectorNew  dateRange={dateRange} setDateRange={setDateRange} />
        </div>
        <button onClick={() => {setdateRangeOpen(!dateRangeOpen)}} className={"bg-orange-500 sm:hidden rounded text-white font-bold p-2 fixed z-10 shadow bottom-2 left-1/2 -translate-x-1/2"}>Open Kalender</button>
        <a href={"/"} className={"justify-center flex items-center bg-red-600 text-white col-span-2 xl:col-span-1 rounded-lg p-3 shadow font-bold gap-2 text-3xl"}>Back</a>
        <div className="gap-2 grid-cols-4 grid col-span-6 xl:col-span-7">
          <div className="gap-4 flex-col w-full bg-white col-span-4 sm:col-span-3 xl:col-span-2 shadow rounded-lg p-3">
            <h1 className="text-center text-2xl md:text-3xl font-bold text-gray-800">
              {machine.alias}
            </h1>
            <div className="text-center text-lg text-gray-600 mt-1">
              {machine.brand} {machine.model}
            </div>
          </div>
          <p className={`gap-3 text-2xl font-bold bg-white justify-center items-center rounded-lg shadow sm:col-span-1 col-span-2 flex sm:hidden xl:flex ${machineStatus ? machineStatus.color: ""}`}>
            {machineStatus.icon}  {machineStatus.status}
          </p>
          <div style={{background: livedata.BatteryTotal > 50 ? "limegreen" : livedata.BatteryTotal > 10 ? "darkorange" : "red"}} className={"text-2xl group font-bold text-white justify-center items-center rounded-lg shadow sm:col-span-1 col-span-2 min-h-20 flex"}>
            {livedata.BatteryTotal.toFixed(0)}%
            <div className="absolute hidden group-hover:block bg-gray-800 bg-opacity-70 font-normal text-white text-sm p-2 rounded-lg shadow-lg w-auto z-10 mx-5">
              Dit is een gemiddelde. Uw individuele percentages zijn:{" "}
              {socValues
                .map((soc, idx) => `Accu ${idx + 1}: ${soc}%`)
                .join("\n")}
            </div>
          </div>
        </div>
        <div className="h-full bg-white rounded-lg sm:flex hidden col-span-2 xl:col-span-1 flex-col gap-2 items-center relative p-3">
          {imgUrl ? (
            <div className="aspect-square rounded-full overflow-hidden flex items-center shadow-gray-400 shadow-xl">
              <img key={serialNumber} src={imgUrl} alt={machine.alias} className="w-full h-full object-cover"/>
            </div>
          ) : (
            <div className={"w-full aspect-square bg-gradient-to-br from-orange-500 to-yellow-400 rounded-full flex items-center shadow-gray-400 shadow-xl"}><h1 className={"w-full font-bold text-5xl text-white text-center"}>{machine.alias[0]}</h1></div>
          )}
          <div className={"h-px w-11/12 bg-gray-500 mt-5"}></div>
          <div className="relative group flex flex-col justify-center items-center rounded-lg w-full">
                <span className="text-xl md:text-lg font-bold text-gray-800">
                  Email
                </span>
            <Switch checked={isSubscribed} onChange={handleSubscriptionToggle}/>
            <p className="text-xs md:text-sm text-gray-600">Voor laadupdate</p>

            <div className="absolute hidden group-hover:block bg-gray-800 text-center w-fit text-wrap bg-opacity-70 text-white text-sm p-2 rounded-lg shadow-lg bottom-20 z-10">
              Meldt u aan om melding te krijgen als uw machine start of stopt
              met laden.
            </div>
          </div>
          <div className={"h-px w-11/12 bg-gray-500 mt-5"}></div>
          <div className="flex justify-center items-center rounded-lg p-3">
            <ManualViewer key={serialNumber} serialNumber={serialNumber} />
          </div>
          <div className={"h-px w-11/12 bg-gray-500"}></div>
          <button onClick={() => {setdateRangeOpen(!dateRangeOpen)}} className={"bg-orange-500 rounded text-white font-bold p-2"}>Open Kalender</button>
        </div>
        <div className={"w-full col-span-8 xl:col-span-7 sm:col-span-6 flex flex-col"}>
          <div className={"w-full flex flex-col gap-2"}>
            <div className={"grid grid-cols-4 gap-2 w-full"}>
              <p className={`gap-3 text-2xl font-bold bg-white justify-center items-center rounded-lg shadow hidden sm:flex xl:hidden ${machineStatus ? machineStatus.color: ""}`}>
                {machineStatus.icon}  {machineStatus.status}
              </p>
              <div className="group relative bg-white rounded-lg p-3 shadow xl:col-start-1 row-start-4 xl:row-start-3 2xl:row-start-2 2xl:col-start-2 text-nowrap 2xl:col-span-1 col-span-4 xl:col-span-3">
                <h2 className="text-base md:text-lg font-semibold text-gray-800">Laad Vermogen</h2>
                <hr className="my-2 border-gray-300" />
                <div className="flex flex-col justify-center items-center p-6">
                  <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800">{chargeWattage} kWh</p>
                </div>
                <div className="absolute hidden group-hover:block bg-gray-800 text-center text-wrap bg-opacity-70 text-white text-sm p-2 rounded-lg shadow-lg top-0 z-10  left-1/2 -translate-x-1/2 w-full">
                  Dit is het laad vermogen hier kan u zien hoeveel kilowatt uur uw machine per uur laad
                </div>
              </div>
              <div className="group relative bg-white rounded-lg p-3 shadow 2xl:row-start-1 row-start-1 xl:row-start-3 col-span-4 sm:col-span-1">
                <h2 className="text-base md:text-lg font-semibold text-gray-800">Draaiuren</h2>
                <hr className="my-2 border-gray-300" />
                <div className="flex flex-col justify-center items-center p-6">
                  <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800">{driverHours}</p>
                </div>
                <div className="absolute hidden group-hover:block bg-gray-800 text-center w-full bg-opacity-70 text-white text-sm p-2 rounded-lg shadow-lg top-0 z-10 left-1/2 -translate-x-1/2">
                  Dit zijn de totale uren die deze machine heeft gedraait
                </div>
              </div>
              <div className="group relative bg-white rounded-lg p-3 col-span-4 shadow xl:col-span-3 2xl:row-start-1 2xl:col-start-3 2xl:col-span-2 row-span-2">
                <h2 className="text-base md:text-lg font-semibold text-gray-800">Scherm Berichten</h2>
                <hr className="my-2 border-gray-300" />
                <ul className="flex flex-col items-center max-h-60 overflow-y-scroll p-6">
                  {ScreenMessages.map((message, i) => (
                    <li className={i % 2 === 0 ? "text-xl font-bold text-gray-900" : "text-xl font-bold text-gray-500"} key={i}>{message}</li>
                  ))}
                </ul>
                <div className="absolute hidden group-hover:block bg-gray-800 text-center w-full text-wrap bg-opacity-70 text-white text-sm p-2 rounded-lg shadow-lg top-0 z-10 left-1/2 -translate-x-1/2">
                  Dit zijn alle schermberichten van de geselecteerde periode
                </div>
              </div>
              <div className="bg-white rounded-lg p-3 shadow row-start-3 sm:row-start-1 col-span-4 sm:col-span-1 2xl:row-start-1 relative group flex flex-col xl:row-start-1 2xl:col-start-1 xl:col-start-4">
                <h2 className="text-base md:text-lg font-semibold text-gray-800">Resterende werktijd</h2>
                <hr className="my-2 border-gray-300" />
                <div className="flex flex-col justify-center items-center p-6">
                  <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800">{workTimeRemaining}</p>
                </div>
                <div className="absolute hidden group-hover:block bg-gray-800 text-center w-full text-wrap bg-opacity-70 text-white text-sm p-2 rounded-lg shadow-lg top-0 z-10 left-1/2 -translate-x-1/2">
                  Dit is de gemiddelde werktijd van uw machine dit is gebaseert op de hoeveelheid verbruik in de geselecteerde periode
                </div>
              </div>
              <div className="bg-white group relative rounded-lg p-3 shadow col-span-4 sm:col-span-1 row-start-2 sm:row-start-1 2xl:row-start-2 xl:row-start-2 2xl:col-start-1 xl:col-start-4">
                <h2 className="text-base md:text-lg font-semibold text-gray-800">Resterende laadtijd</h2>
                <hr className="my-2 border-gray-300" />
                <div className="flex flex-col justify-center items-center p-6">
                  <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800">{chargeTime}</p>
                </div>
                <div className="absolute hidden group-hover:block bg-gray-800 text-center w-full text-wrap bg-opacity-70 text-white text-sm p-2 rounded-lg shadow-lg top-0 z-10 left-1/2 -translate-x-1/2">
                  Resterende laadtijd gebaseerd op het huidige laadvermogen.
                </div>
              </div>
            </div>
            <div className={"w-full 2xl:flex-row flex-col flex gap-2"}>
              <div className={"2xl:w-1/2 w-full bg-white rounded-lg p-6 shadow"}>
                <span className={"flex justify-between"}>
                  <div className={"flex gap-5 items-baseline"}>
                    <h2 className="text-base md:text-lg font-semibold text-gray-800 ">Verbruikte Energie</h2>
                    <div className={"flex gap-3 items-center"}>
                      <h1 className={"font-semibold text-sm text-gray-600"}>Grafiek/Tabel</h1>
                      <Switch onClick={() => {setTabel(!Tabel)}} value={Tabel} checked={Tabel} size={"small"}/>
                    </div>
                  </div>
                  <div className={"relative flex items-center gap-2"}>
                    <div id={"filters"} style={{display: "none"}} className={"absolute top-10 h-fit text-nowrap w-fit bg-gray-100 rounded shadow right-6 p-3 text-black"}>
                      {Object.entries(filters).map((filter, i) => (
                        <div className={"flex gap-1 items-center font-semibold text-gray-800"} key={i}>
                          <div style={{background: filter[1].color}} className={"h-3 w-3"}></div>
                          <h1 id={filter[0]} onClick={(e) => {setFilters({...filters, [e.target.id]: {...filters[e.target.id], value: !filters[e.target.id].value}})}}>{filter[1].name} {filter[1].value ? "Aan" : "Uit"}</h1>
                        </div>
                      ))}
                    </div>
                    <button onClick={() => {document.getElementById("filters").style.display = document.getElementById("filters").style.display === "none" ? "block" : "none"}} className={"font-semibold text-sm text-white p-1 rounded bg-orange-500"}>Filters</button>
                    <button onClick={() => {exportData()}} className={"font-semibold text-sm text-white p-1 rounded bg-orange-500"}>Export</button>
                  </div>
                </span>
                <div className={"hidden"}>
                  <EnergyTable machine={machine} name={"draw-tabel"} filters={filters} Data={Data} Draw={true} totals={Totaal}/>
                  <EnergyChart name={"draw-chart"} Data={Data} filters={filters} Draw={true}/>
                </div>
                {Tabel ?
                  <EnergyTable machine={machine} name={"tabel"} filters={filters} Data={Data} Draw={false} totals={Totaal}/>
                  :
                  <EnergyChart name={"chart"} Data={Data} filters={filters} Draw={false}/>
                }

              </div>
              <div id={"test"} className={"2xl:w-1/2 h-full min-h-96"}>
                <NewMachineGPSPanel metaData={machine} liveData={livedata} />
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default MachineDashboard;
